import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { IID_MAIL_GTW_SOURCE } from "@common/interfaces/interfaceData";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIdMailGtwState extends EntityState<IID_MAIL_GTW_SOURCE, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_MAIL_GTW_SOURCE , realtimeEntity: 'IID_Mail_gtw'})
@InterfaceDataStore(InterfaceName.MAIL_GTW_SOURCE)
export class IIDMailGtwStore extends EntityStore<IIdMailGtwState> {
  constructor() {
    super([]);
  }
}
